/**
 * Use this to calculate the amount if items to be shown in a column.
 * @param itemsLength // Amount of items to divide into columns
 * @param columns // The desired amount of items in a column. E.g. 4 items in a column.
 *
 * Eg. on desktop we wan't 4 items in each of the 4 columns. But when we have more than 16 items,
 * we need do calculate how many each column should have instead.
 * Eg. If there is 20 items, we need to have 5 items in each column instead of 4.
 * So when we have many items return @constant amountItemsInEachRows, to make it fit
 */
export const caluclateItemInRows = (itemsLength: number, columns: number) => {
	if (itemsLength <= columns) {
		return itemsLength;
	}

	const amountItemsInEachRows = Math.ceil(itemsLength / columns);
	return amountItemsInEachRows <= columns ? columns : amountItemsInEachRows;
};
